import { getApiClient, getStorage } from './client'
import type { User, AuthTokens, LoginRequest, LoginResponse, ApiResponse } from '@vestolio/shared'

export const authApi = {
  login: async (payload: LoginRequest): Promise<LoginResponse> => {
    const { data } = await getApiClient().post('/auth/login', payload)
    return data
  },

  register: async (payload: {
    email: string
    password: string
    name: string
  }): Promise<LoginResponse> => {
    const { data } = await getApiClient().post('/auth/register', payload)
    return data
  },

  me: async (): Promise<ApiResponse<User>> => {
    const { data } = await getApiClient().get('/auth/me')
    return data
  },

  refresh: async (refreshToken: string): Promise<AuthTokens> => {
    const { data } = await getApiClient().post('/auth/refresh', { refreshToken })
    return data
  },

  forgotPassword: async (email: string): Promise<ApiResponse<void>> => {
    const { data } = await getApiClient().post('/auth/forgot-password', { email })
    return data
  },

  resetPassword: async (token: string, password: string): Promise<ApiResponse<void>> => {
    const { data } = await getApiClient().post('/auth/reset-password', { token, password })
    return data
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<ApiResponse<void>> => {
    const { data } = await getApiClient().post('/auth/change-password', { currentPassword, newPassword })
    return data
  },

  logout: async (): Promise<void> => {
    const storage = getStorage()
    try {
      await getApiClient().post('/auth/logout')
    } catch {
      // Ignore logout API errors
    }
    await storage.removeItem('token')
    await storage.removeItem('refreshToken')
  },
}